/**
 * https://www.pdftron.com/api/web/Core.DocumentViewer.html#displaySearchResult__anchor
 */
export default result => {
  window.documentViewer.displaySearchResult(result);
};
